// extracted by css-extract-rspack-plugin
export default {"container":"_3c2b090d","isFirstMonthWeek":"_eff39fe6"};